export { _makeCancelable as makeCancelable };

// Pulled from here: https://stackoverflow.com/questions/29478751/cancel-a-vanilla-ecmascript-6-promise-chain/37492399#37492399
/**
 * This method adds the ability to "cancel" a promise. T
 * @param promiseGenerator a function that returns a promise and takes a single
 *        parameter which is a function which can be used to see if the promise
 *        has been canceled. This makes it a bit easier to figure out when to
 *        dump out of a current logic block.
 * @returns {{cancel(): void, promise: Promise<any>}}
 * @example
 * const cancelableResult = makeCancelable(function(isCanceledFunc) {
 *   params.isCanceledFunc = isCanceledFunc; //NOTE: not required if you don't need to check for cancelled
 *   return promiseToMakeCancelable(context, params);
 * });
 * cancelableResult.promise
 *   .then(() => {
 *     // handle success
 *   })
 *   .catch(err => {
 *     if (err.isCanceled) {
 *       // handle if canceled
 *     }
 *     // handle standard error
 *   });
 * cancelableResult.cancel();
 */
const _makeCancelable = function (promiseGenerator) {
  let _hasCanceled = false;
  const isCanceledFunc = () => _hasCanceled;
  const wrappedPromise = new Promise((resolve, reject) => {
    promiseGenerator(isCanceledFunc)
      .then((val) =>
        _hasCanceled ? reject({ isCanceled: true }) : resolve(val)
      )
      .catch((error) =>
        _hasCanceled ? reject({ isCanceled: true }) : reject(error)
      );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      _hasCanceled = true;
    },
  };
};
